import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { withPage } from "../../Page";
import ActionCreator from "../../ActionCreator";
import * as Widget from "../../Components/Widget2";
import FindIntroduction from "../../Components/FindIntroduction";
import Image from "../../Components/Image";
import * as ReactScroll from "react-scroll";
import ChattyButton from "../../../chatty/Components/ChattyButton";

let AromaData = [
  { name: "fruit", display: "果香", img1: "icon07.png", img2: "icon13.png" },
  { name: "land", display: "土地芬芳", img1: "icon08.png", img2: "icon14.png" },
  { name: "smoked", display: "煙熏", img1: "icon09.png", img2: "icon15.png" },
  { name: "flower", display: "花香", img1: "icon10.png", img2: "icon16.png" },
  { name: "berry", display: "莓果", img1: "icon11.png", img2: "icon17.png" },
  { name: "nut", display: "堅果", img1: "icon12.png", img2: "icon18.png" }
];

const UiState = {
  fruit: "fruit",
  land: "land",
  smoked: "smoked",
  flower: "flower",
  berry: "berry",
  nut: "nut"
};

class FindAromaPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uiState: ""
    };
  }
  render() {
    let { navActions } = this.props;
    let { uiState } = this.state;

    return (
      <Wrapper
        css={`
          margin-top: 112px;
          @media screen and (max-width: 1000px) {
            margin-top: 40px;
          }
          @media screen and (max-width: 550px) {
            margin-top: 20px;
          }
        `}
      >
        <div className="left">
          <div className="title">- 尋香氣 -</div>
          <div className="subtitle">請選擇你喜愛的氣味</div>
          <Widget.Row
            wrap={"true"}
            css={`
              max-width: 100%;
              @media screen and (max-width: 1000px) {
                justify-content: center;
              }
            `}
          >
            {AromaData.map(({ name, display, img1, img2 }, idx) => (
              <AromaItem
                key={idx}
                onClick={() => {
                  this.setState({ uiState: name }, () => {
                    // only need scrolling when column layout (ex. mobile device)
                    if (window.innerWidth <= 1000) {
                      ReactScroll.animateScroll.scrollMore(400);
                    }
                  });
                }}
                selected={uiState === name}
                css={`
                  margin-right: ${(idx + 1) % 3 == 0 ? "0" : "33"}px;
                  margin-bottom: 36px;
                  @media screen and (max-width: 550px) {
                    margin-right: ${(idx + 1) % 3 == 0 ? "0" : "20"}px;
                  }
                  @media screen and (max-width: 375px) {
                    margin-right: ${(idx + 1) % 3 == 0 ? "0" : "10"}px;
                  }
                `}
              >
                <img
                  src={`/images/pages/products/${
                    uiState !== name ? img1 : img2
                  }`}
                />
                <div>{display}</div>
              </AromaItem>
            ))}
          </Widget.Row>
        </div>
        <div className="right">
          {uiState === "" && (
            <div className="cover-img">
              <Image background src="./images/pages/find/1.png" />
            </div>
          )}
          {uiState === UiState.fruit && (
            <FindIntroduction find={UiState.fruit} />
          )}
          {uiState === UiState.land && <FindIntroduction find={UiState.land} />}
          {uiState === UiState.smoked && (
            <FindIntroduction find={UiState.smoked} />
          )}
          {uiState === UiState.flower && (
            <FindIntroduction find={UiState.flower} />
          )}
          {uiState === UiState.berry && (
            <FindIntroduction find={UiState.berry} />
          )}
          {uiState === UiState.nut && <FindIntroduction find={UiState.nut} />}
        </div>
        <ChattyButton />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;

  max-width: 1140px;
  width: 100%;
  margin: 0 auto;
  min-height: 900px;

  & > .left {
    padding: 20px;
    max-width: 500px;
    width: 100%;

    & > .title {
      margin-bottom: 20px;
      letter-spacing: 3.9px;
      font-size: 26px;
    }

    & > .subtitle {
      margin-bottom: 50px;
      font-size: 14px;
      color: #636363;
    }
  }

  & > .right {
    padding: 20px;
    flex: 1;

    & > .cover-img {
      width: 100%;
      height: 450px;
      background-color: lightgray;
    }
  }

  @media screen and (max-width: 1000px) {
    flex-direction: column;
    & > .left {
      padding: 10px;
      text-align: center;
      align-self: center;
    }

    & > .right {
      margin-bottom: 100px;
      padding: 73px;
    }
  }

  @media screen and (max-width: 600px) {
    & > .right {
      padding: 40px;
    }
  }

  @media screen and (max-width: 550px) {
    & > .right {
      padding: 20px;

      & > .cover-img {
        max-width: 400px;
        height: 273px;
      }
    }
  }

  @media screen and (max-width: 375px) {
    & > .left {
      max-width: 100%;
    }
    & > .right {
      padding: 10px;
    }
  }

  ${props => props.css};
`;

const AromaItem = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  padding: 20px;
  max-width: 112px;
  width: 100%;
  min-height: 130px;
  border-radius: 5px;
  box-shadow: 0 2px 8px -2px rgba(58, 58, 58, 0.5);
  background: ${props => (props.selected ? "#BD9F84" : "white")};

  & > img {
    margin-bottom: 15px;
    width: 80px;
    height: 80px;
  }

  & > div {
    font-size: 16px;
    color: ${props => (props.selected ? "white" : "black")};
  }

  @media screen and (max-width: 375px) {
    max-width: 90px;
    min-height: 104px;

    & > img {
      margin-bottom: 5px;
      width: 60px;
      height: 60px;
    }

    & > div {
      font-size: 12px;
    }
  }

  ${props => props.css}
`;

export default withPage(
  connect(
    null,
    ActionCreator
  )(FindAromaPage)
);
